import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocalMovies = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 3V21",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 21V3",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21Z",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 7H3",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 17H3",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 17H21",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 7H21",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 12H3",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLocalMovies);
export default ForwardRef;
